import { render, staticRenderFns } from "./AssignTaskBadgeModal.vue?vue&type=template&id=e29d51e0"
import script from "./AssignTaskBadgeModal.vue?vue&type=script&lang=js"
export * from "./AssignTaskBadgeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports